<template>
  <el-form-item label="配送区域">
    <el-select v-model="delivery" filterable placeholder="请选择或输入" clearable @change="handleChange">
      <el-option
        v-for="(item,index) in deliveryList"
        :key="index"
        :label="item.regionname"
        :value="item.regioncode"
        :title="item.regionname"
      ></el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import api from "../../apis/api.js";
export default {
  name: "DeliveryAreaSelect",
  data() {
    return {
      deliveryList: [], //配送方列表
      delivery: "" // 商品分类编号
    };
  },
  methods: {
    getDatas: function() {
      api.GET_REGIONINFOLIST({ status: 1 }).then(res => {
        if (res.data.status == "200") {
          this.deliveryList = res.data.data;
        }
      });
    },
    // 下拉框取值
    handleChange(value) {
      // console.log(value,'已选商品分类编号');
      this.$emit("deliveryObtain", value);
    }
  },
  mounted: function() {
    this.getDatas();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/DeliveryAreaSelect.vue